import './utils';
import { Actions } from './app-actions';
import filter from 'lodash/filter';

// Sets item in reducer as loading, clears error for that item
const itemLoading = (state, prefix) => {
    return {
        ...state,
        [`${prefix}Error`]: null,
        [`${prefix}Loading`]: true,
    };
};

// todo: perhaps we need loading/errors to be based on particular ids i.e. dont show user 2 as saving if it's just user 1
// Sets item in reducer as saved, clears error for that item
const itemLoaded = (state, prefix, action) => {
    if (action.index) { // Item is part of a collection, add it within the prefix
        return {
            ...state,
            [prefix]: { ...state[prefix], [action.index]: action.data },
            [`${prefix}Error`]: null,
            [`${prefix}Loading`]: false,
        };
    }
    return {
        ...state,
        [`${prefix}Error`]: null,
        [`${prefix}Loading`]: false,
        [prefix]: action.data };
};

// Adds an item to the reducer collection, if one exists with the same ID it will be updated
// eslint-disable-next-line no-unused-vars
const appendItem = (state, prefix, action) => {
    return {
        ...state,
        [prefix]: filter(state[prefix], i => i.id !== action.id || action.data.id).concat([action.data]),
    };
};

// Removes an item from a collection based on an ID
// eslint-disable-next-line no-unused-vars
const deleteItem = (state, prefix, action) => {
    return {
        ...state,
        [prefix]: filter(state[prefix], i => i.id !== action.id),
    };
};

const itemError = (state, prefix, action) => {
    return {
        ...state,
        [`${prefix}Loading`]: false,
        [`${prefix}Error`]: action.error,
    };
};

function defaultReducer(
    state = {
        isConnected: true,
    },
    action,
) {
    if (typeof window === 'undefined') {
        // API.log('SERVER', action.type);
    } else {
        // API.log('DISPATCHER', action.type);
    }
    switch (action.type) {
        case Actions.LOGIN_LOADED:
        case Actions.UPDATE_USER_LOADED:
        case Actions.CONFIRM_EMAIL_LOADED:
        case Actions.REGISTER_LOADED:
        case Actions.LOGIN_WITH_TOKEN_LOADED:
            return itemLoaded(state, 'user', action);
        case Actions.LOGIN_ERROR:
        case Actions.CONFIRM_EMAIL_ERROR:
        case Actions.REGISTER_ERROR:
        case Actions.UPDATE_USER_ERROR:
        case Actions.LOGIN_WITH_TOKEN_ERROR:
            return itemError(state, 'user', action);
        case Actions.USER_LOADING:
            state.userLoading = action.status;
            return { ...state };
        case Actions.REGISTER:
        case Actions.UPDATE_USER:
        case Actions.CONFIRM_EMAIL:
        case Actions.LOGIN:
        case Actions.LOGIN_WITH_TOKEN:
            return itemLoading(state, 'user', action);
        case Actions.CLEAR_USER:
            return { ...state, user: null, subscriptions: null };
        case Actions.STARTUP_LOADED:
            return { ...state, ...action.data };
        case Actions.CHECK_SUBSCRIPTION:
            return itemLoading(state, 'subscriptions', action);
        case Actions.CHECK_SUBSCRIPTION_LOADED:
            return itemLoaded(state, 'subscriptions', action);
        case Actions.CHECK_SUBSCRIPTION_ERROR:
            return itemError(state, 'subscriptions', action);
        case Actions.GET_PLANS:
            return itemLoading(state, 'plans', action);
        case Actions.GET_PLANS_LOADED:
            state.plans = _.sortBy(action.data, plan => plan.id.includes('yearly') ? 0 : plan.id.includes('quarterly') ? 1 : 2)
            state.plansError = null;
            state.plansLoading = false;
            return { ...state };
        case Actions.GET_PLANS_ERROR:
            return itemError(state, 'plans', action);
        case Actions.GET_NEXT_SUBSCRIPTION:
        case Actions.UPDATE_NEXT_SUBSCRIPTION:
            return itemLoading(state, 'nextSubscription', action);
        case Actions.GET_NEXT_SUBSCRIPTION_LOADED:
        case Actions.UPDATE_NEXT_SUBSCRIPTION_LOADED:
            return itemLoaded(state, 'nextSubscription', action);
        case Actions.GET_NEXT_SUBSCRIPTION_ERROR:
        case Actions.UPDATE_NEXT_SUBSCRIPTION_ERROR:
            return itemError(state, 'nextSubscription', action);
        case Actions.GET_CURRENCY:
            return itemLoading(state, 'currency', action);
        case Actions.GET_CURRENCY_LOADED:
            return itemLoaded(state, 'currency', action);
        case Actions.GET_CURRENCY_ERROR:
            return itemError(state, 'currency', action);
        case Actions.GET_COUNTRY:
            return itemLoading(state, 'country', action);
        case Actions.GET_COUNTRY_LOADED:
            return itemLoaded(state, 'country', action);
        case Actions.GET_COUNTRY_ERROR:
            return itemError(state, 'country', action);
        case Actions.GET_COUPONS:
            return itemLoading(state, 'coupons', action);
        case Actions.GET_COUPONS_LOADED:
            return itemLoaded(state, 'coupons', action);
        case Actions.GET_COUPONS_ERROR:
            return itemError(state, 'coupons', action);
        case Actions.GET_COUPON:
            return itemLoading(state, 'coupon', action);
        case Actions.GET_COUPON_LOADED:
            return itemLoaded(state, 'coupon', action);
        case Actions.GET_COUPON_ERROR:
            return itemError(state, 'coupon', action);
        case Actions.CLEAR_COUPON:
            return { ...state, coupon: null };
        case Actions.GET_COUPON_APPLIED:
            return itemLoading(state, 'couponApplied', action);
        case Actions.GET_COUPON_APPLIED_LOADED:
            return itemLoaded(state, 'couponApplied', action);
        case Actions.GET_COUPON_APPLIED_ERROR:
            return itemError(state, 'couponApplied', action);
        case Actions.CANCEL_SUBSCRIPTION_LOADED:
            return itemLoaded(state, 'nextSubscription', {});
        case Actions.SEND_STAR_CLUB_TSHIRT_ORDER_DETAILS:
            return itemLoading(state, 'starClubOrderDetails', action);
        case Actions.SEND_STAR_CLUB_TSHIRT_ORDER_DETAILS_LOADED:
            if (state.user?.star_club_membership) {
                state.user.star_club_membership.tshirt_ordered = true;
            }
            return itemLoaded(state, 'starClubOrderDetails', action);
        case Actions.SEND_STAR_CLUB_TSHIRT_ORDER_DETAILS_ERROR:
            return itemError(state, 'starClubOrderDetails', action);
        // END OF REDUCER
        // KEEP THE ABOVE LINE IN, IT IS USED BY OUR CLI
        default:
            return state;
    }
}

export default defaultReducer;
